export default __webpack_public_path__ + "static/media/cursedbyhell.d700187d.png";